// extracted by mini-css-extract-plugin
export default {"CardTile":"CardTile_CardTile__IaXFt","card-img":"CardTile_card-img__M5L+Z"};